import React from "react";
import {
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Text,
	Link,
} from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";

const FundInFocusApril: React.FC = () => (
	<>
		{/* members */}
		<Flex
			as="section"
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height={{ xs: "450px", sm: "300px" }}
			minH={{ xs: "450px", sm: "300px" }}
			maxH="450px"
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/jpg/blogBanner.jpg"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDir="column"
				px={{ xs: "20px", sm: "28px", md: "45px", lg: "60px", xl: "inherit" }}
			>
				<Heading
					as="h1"
					mb="20px"
					variant="reportCardTitle"
					fontSize={{ xs: "26px", sm: "28px", md: "32px", lg: "38px" }}
					color="white"
					lineHeight={{ xs: "34px", md: "39px", lg: "42px" }}
				>
					FUND IN FOCUS: Completing a Decade of Underwriting Private Debt in
					India - Investec Capital Continues to Address the Credit Gap of
					Mid-Market Cos. in the Region
				</Heading>
			</Container>
		</Flex>
		<Container
			as="section"
			maxW="container.xl"
			pb="80px"
			pt="40px"
			minH="420px"
			display={{ xs: "flex", md: "inherit" }}
			flexDirection="column"
		>
			<Box as="main" w="100%" pb="40px">
				<Text variant="blogAnswer">
					Welcome to our ‘Fund in Focus’ series where we profile our member
					funds, underscore their investment philosophy, and highlight some of
					their interesting work. Today we speak to{" "}
					<Link
						href="https://www.linkedin.com/in/piyush-gupta-a2533516/"
						target="_blank"
						style={{
							textDecoration: "underline",
						}}
						rel="noreferrer"
					>
						Piyush Gupta
					</Link>
					, Head of Credit Markets,{" "}
					<Link
						href="https://www.investec.com/en_in.html"
						target="_blank"
						style={{
							textDecoration: "underline",
						}}
						rel="noreferrer"
					>
						Investec Capital Services
					</Link>
					. In this feature he throws light on India’s growing base of
					mid-market businesses and Investec’s commitment to financing the
					growth needs with structured private credit solutions.
				</Text>
			</Box>

			<Img
				src="https://static.levocdn.com/WGLBUT82/7054365989327536183.jpg"
				alt="Anjani Bansal"
				width="300px"
				float={{ xs: "right", md: "left" }}
				alignSelf={{ xs: "center", md: "flex-start" }}
				mx={{ xs: "0px", md: "0px" }}
				mr={{ xs: "0px", md: "40px", lg: "60px", xl: "70px" }}
				mb="20px"
				objectFit="contain"
			/>
			<Box>
				<Link
					href="https://www.linkedin.com/in/piyush-gupta-a2533516/"
					target="_blank"
				>
					<IconButton
						aria-label="linkedin"
						icon={<FaLinkedin size="28px" color="rgba(100, 100, 140, 0.6)" />}
						variant="unstyled"
						cursor="pointer"
					/>
				</Link>
				<Box
					ml={{ xs: "auto", md: "345px", lg: "370px" }}
					mr={{ xs: "auto", md: "0px" }}
					width={{ xs: "160px", md: "80px" }}
					h="2px"
					bgColor="primary.500"
					borderRadius="5px"
					mt={{ xs: "16px", md: "10px" }}
					mb="15px"
				/>
				<Box mt="16px" mb="20px">
					<Heading variant="blogQuestion" mb="20px">
						1. How would you describe the investment philosophy of Investec
						India?
					</Heading>
					<Text variant="blogAnswer">
						Investec has been underwriting credit for mid-market businesses and
						sponsors in India for 10 years now. Over this period, Investec has
						participated in over US$ 5bn of financing across INR and FCY, having
						underwritten over US$ 1.7bn in 50+ financings. The strategy is
						sector agnostic and aimed at supporting mid-market businesses and
						sponsors to provide credit solutions for their non-bank end uses.
						<br />
						<br />
						We typically make senior secured structured credit investments
						focused on mid-market companies. The strategy cuts across risk
						return spectrum, catering to a wide spectrum of end uses which are
						typically not catered to by traditional providers of capital
						including but not limited to M&A financing, leveraged finance, stake
						consolidation, refinancing, capital structure alignment, bridge
						financing, dividend recapitalization, growth capex. etc. We
						typically focus on leading mid-market companies with strong pedigree
						and corporate governance, steady profitability and free cash flow
						generation track record with robust growth prospects. We have had
						zero credit losses till date in our portfolio notwithstanding
						multiple credit shocks in the Indian credit market.
					</Text>
				</Box>
				{/* Question 2 */}
				<Flex mt="8" mb="20px" gap="1rem">
					<Box>
						<Heading variant="blogQuestion" pb="20px" pt="12px">
							2. Tell us how has the Emerging India Credit Opportunities Fund I
							by Investec been deployed so far? Do share some exciting work of
							some of your portfolio companies.
						</Heading>

						<Text variant="blogAnswer" pt="8px">
							Investec’s maiden credit fund in India (Emerging India Credit
							Opportunities Fund I (EICOF I) achieved its final close at INR
							1,250cr in September 2022 (including INR 250cr of minimum sponsor
							co-investment). EICOF I has already drawdown ~85% of total capital
							commitments for portfolio investments. Most of our portfolio
							companies are amongst market leading, mid-market corporate players
							catering to specialised segments in their industries/sectors. We
							currently have a healthy pipeline and are evaluating several
							transactions at multiple stages for potential investments by the
							Fund.
							<br />
							<br /> Till date, the Fund has made 7 investments and 2 more are
							at execution stage. So, by end April, the Fund would have made 9
							investments across sectors like renewables, manufacturing,
							building materials, pharma & allied businesses, design engineering
							and ITeS. The Fund has already successfully made 2 complete exits
							and 3 partial exits in line with Investec’s successful exit track
							record. The end uses for which the Fund financed the
							aforementioned portfolio companies typically included M&A, stake
							consolidation, refinancing and capex growth. One of our portfolio
							companies in the renewables sector, majority owned by global
							financial sponsors, is one of the leading C&I (Commercial and
							Industrial) solar platform (on-site and open access) in India with
							a growing presence in Southeast Asia. It provides customised solar
							solutions to help businesses meet sustainability targets while
							ensuring cost benefits of between 30-60% on electricity consumed.
							Key offerings include Offsite Solar/ Wind, Onsite Solar,
							Wind-solar hybrid, Energy Storage, EV charging stations etc. with
							key focus on rapid scale up of the platform both via organic and/
							or inorganic growth routes.
							<br />
							<br />
							Another portfolio company is the leading player in the Railway
							Track Engineering space and manufactures concrete sleepers, rail
							fittings for normal track, elevated & underground track for metro
							rail and ballastless track suitable specially for high-speed
							lines. The Company is the only player in this space with a
							pan-India presence and has ~15 plants with a cumulative
							manufacturing capability of over 6 million sleepers per annum. The
							group services over 1/4th of total sleepers required by Indian
							Railways and has a market leading position in overall sleepers’
							market in India. The company has constantly innovated as per
							Indian Railways need and has constantly expanded its product suite
							from wooden to composite to wide gauge sleepers which has much
							better load bearing capacity thereby optimising the goods movement
							efficiency.
							<br />
							<br />
							Given its stellar track record in sleeper manufacturing and
							technical know-how that the Company has gained over the years it
							is expected to be a key beneficiary of future projects undertaken
							by the Indian Railways.
						</Text>
					</Box>
					<Img
						mt="20px"
						src="https://static.levocdn.com/WGLBUT82/7054367512553970696.jpg"
						alt="Infographic"
						w="43%"
						objectFit="contain"
						display={{ xs: "none", sm: "block" }}
					/>
				</Flex>

				{/* Question 3 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="28px">
						3. Which sectors in India is Investec excited for growth opportunity
						in current decade?
					</Heading>
					<Text variant="blogAnswer" mt="16px" mb="8px">
						India’s growth has been driven by public and private capital
						expenditure, thrust on indigenization through Make in India, PLI
						schemes, stable political environment focused on sustained policy
						reforms, favourable demographics and “China +1” strategy among other
						factors. The growth in Indian economy has been evidenced by India’s
						GDP growth estimates, which in 2022 were more than double the
						world’s average estimates. We believe that the growth levers driving
						growth in the Indian economy will persist and our outlook remains
						buoyant on the broader India growth theme.
						<br />
						<br />
						Several of our portfolio companies are in an exciting phase of their
						growth journey with respective sectors such as infrastructure and
						pharma allied manufacturing, renewables among others which are
						witnessing strong push by the GoI as well as attracting significant
						private capital.
					</Text>
				</Box>

				{/* Question 4 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						4. According to latest data by EY - Private credit saw more than 83
						transactions valued at $3.85 billion i.e., a 47% rise from the same
						period last year. What factors are leading Indian mid-market
						companies to tap credit funds?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						Indian credit markets have seen several structural disruptions in
						the last decade including, amongst others, slowdown in banks credit
						growth, NBFC liquidity squeeze triggered by events in 2018, COVID
						pandemic etc. These disruptions have led to several constraints
						being faced by traditional providers of debt capital including
						banks, NBFCs and mutual funds which presented an opportunity for
						Private credit as an asset class to grow significantly by providing
						flexible, bespoke solutions catering to the needs of mid-market
						companies and sponsors.
					</Text>
				</Box>
				{/* Question 5 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						5. What’s your outlook for LBO asset class for 2023 in India?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						2021 was a record year for PE/VC investments in India, recording an
						all-time high of US$75.9 billion. Post the initial shock of the
						pandemic, central banks globally encouraged a low interest rate
						environment which led to massive capital influx in the PE VC space
						but witnessed retraction as markets corrected globally in 2022.
						<br />
						<br />
						However, Q4 CY22 witnessed increased PE VC investments vs Q3 CY22
						and India focused financial sponsors are sitting on record amounts
						of dry powder to be put to work in the months to come. India
						dedicated fundraise witnessed a 125% growth in 2022 also which
						underscores the relative value and attractiveness for India
						investments. In addition to the increase in India dedicated
						fundraises, there is a high level of dry powder outstanding globally
						of over ~US$1.5tn (across buyout and growth investments) and a
						disproportionate allocation can be expected towards India amongst
						EMs on the back of relatively stronger economic growth outlook.
						<br />
						<br />
						This asset class continues to showcase resilience, growth in demand
						and consistent outperformance viz a viz other asset classes. Private
						equity deal mix has also been witnessing a constant shift towards
						higher deal sizes as also an increasing proportion of buyouts which
						are typically more amenable to leverage.
					</Text>
				</Box>
				{/* Question 6 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						6. Private Credit as an asset class is still in initial stages. How
						do you think will the development of this asset class will fare
						against other emerging economies?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						While private credit asset in India has witnessed rapid growth in
						the last few years, it is still in its early stage of evolution
						relatively viz a viz global developed economy. The opportunity for
						alternate, private credit solutions is quite large as India has
						historically been a Bank dominated debt market and the domestic
						corporate bond market is still to realise its potential particularly
						for the non-AAA/ AA issuers. The liquidity and credit squeeze
						triggered by events in 2018 led to a significant retraction of NBFCs
						and credit mutual funds from the mid-market direct lending market.
						All this presents an exciting opportunity for private credit in
						India to plug the gap in the mid-market direct lending space.
						<br />
						<br />
						India private credit space has been buoyant and supported by
						favourable policy reforms including the introduction and evolution
						of Insolvency and Bankruptcy Code, dedicated tribunals and other
						business supportive reforms providing the ideal launch base for
						private credit space in India. Recent correction in equity capital
						markets coupled with retracting liquidity has furthered the
						non-traditional private credit market where in the market
						participants are able to cater to financing needs via tightly
						structured private credit solutions.
						<br />
						<br />
						The regulators have now put in a comprehensive framework for AIFs in
						India with slew of announcements made recently to further tighten
						the regulatory framework for the AIFs. Relative to many other
						emerging economies, India presents a very large domestic base of
						mid-market businesses and sponsors across manufacturing and
						services. India’s relatively more benign economic growth outlook and
						macroeconomic metrics, an improving ease of doing business, secular
						capex push by the Government and relative attractiveness for global
						pools of capital augurs an exciting growth in mid-market businesses
						which will have corresponding capital requirement both from equity
						as well as debt investors.
					</Text>
				</Box>
			</Box>
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				The content in this section is curated by Team IVCA. For any feedback,
				connect with&nbsp;
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default FundInFocusApril;
